module.exports = __webpack_public_path__ + "static/img/banner_2026_1_2-.8063fbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_2026_1_2-.jpg
// module id = qpO3
// module chunks = 17